export const downloadFile = (url: string, fileName: string) => {
    fetch(url, { method: "get", referrerPolicy: "no-referrer" })
        .then((res) => res.blob())
        .then((res) => {
            const link = document.createElement("a");
            link.setAttribute("download", fileName);
            const href = URL.createObjectURL(res);
            link.href = href;
            link.setAttribute("target", "_blank");
            link.click();
            URL.revokeObjectURL(href);
        });
}